import React from 'react';
import './FeedMessage.css';
import Message from './Message';
import Friend from './Friend';

function FeedMessage({messOpen, userId, email, findFri}) {
    return (
        <div className={`feedMessage ${messOpen && "feedMessage__show"}`}>
            <Message />
            <Friend 
            userId = {userId} 
            email={email}
            findFri = {findFri}
            />
        </div>
    )
}

export default FeedMessage
